import { TranslationObject } from '@ngx-translate/core';
import { AspectDimensions } from '@lib.core/entities/indicator/indicator';
import { KPI } from '@lib.core/entities/indicator/kpi';

export class KPIDTO {
  title!: TranslationObject;
  description!: TranslationObject;
  unit!: string;
  value!: number;
  dimensions!: AspectDimensions;
  performance1y?: number;
  performance5y?: number;
  performance1m?: number;

  static toKPI(kpiDTO: KPIDTO): KPI {
    const {
      title, description, unit, value, dimensions,
      performance1y, performance5y, performance1m
    } = kpiDTO;
    return new KPI(
      title,
      description,
      unit,
      value,
      dimensions,
      performance1y,
      performance5y,
      performance1m
    );
  }
}